module.exports = __webpack_public_path__ + "static/media/benefits_gifts.94091aee.svg";